/**
 * RawJSON is useful when we can not rely on BigInt due to browser incompatibility.
 * For example:
 * - If there is no BigInt support in the browser, we may want to represent long numbers as a string/BigNumber or some custom object.
 * - When we `stringify` the value, we need to know how to serialize that value to a JSON.
 * - The value should not be escaped as a string and should be serialized as is (as a raw value)
 * - This is where `rawJSON` helper can be useful: inside the `stringify` function RawJSON instance can be identified and serialized properly
 */
class RawJson {
    constructor(value) {
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
}
export const isRawJSON = (value) => value instanceof RawJson;
export const rawJSON = (value) => new RawJson(value);
//# sourceMappingURL=raw-json.js.map